import React from "react";

const SvgLightning = props => <svg width={14} height={26} {...props}><path stroke="currentColor" fill="none" strokeLinejoin="round" d="M1 14.9L8.6 1 7.3 11.1H13L6 25l1.3-10.1H1z" /></svg>;

export default "//cdn.scentbird.com/assets/frontbird-site/images/lightning_60d2dd.svg";
export { SvgLightning as ReactComponent };